// src/features.js
export const features = { 
  aiwaveMotion: true 
}; 